const {
  deepOrange,
  deepPurple,
  blue,
  green,
  red,
  pink,
  cyan,
  indigo,
  teal,
} = require('@material-ui/core/colors');

const colors = [
  deepOrange,
  deepPurple,
  blue,
  green,
  red,
  pink,
  cyan,
  indigo,
  teal,
];

export default function () {
  const random = Math.floor(Math.random() * colors.length);
  return colors[random][500];
}
